import { IObjectInfo } from '../../types/objectInfo';
import { TReduxActions } from '../../types/redux';

export const defaultObjectInfoState: IObjectInfo = {
  fromDeveloperPropsCount: 0,
  objectId: -1,
  objectName: '',
  formattedObjectName: '',
  rating: 0,
  sections: [],
  objectUrl: '',
  reviewsCount: 0,
  reviewDescription: [],
  questionsCount: 0,
  questionsCountText: '',
  reviewsCountText: '',
  ratingText: '',
  mlReview: null,
  seoData: {
    title: '',
    description: '',
    location: '',
  },
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export function objectInfoReducer(state: IObjectInfo = defaultObjectInfoState, action: TReduxActions) {
  return state;
}
